import React from 'react';

import SelectInput from '@common/components/SelectInput/SelectInput';
import { Box } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

import { copyObjectWithoutRef } from '@common/helpers/helpers';

export default function EditorLanguageSelector({
  availableLangOptions = [],
  onChange = () => {},
  currentLanguage,
}) {
  return (
    <SelectInput
      options={availableLangOptions.map((option) => {
        const optionCopy = copyObjectWithoutRef(option);
        if (optionCopy?.isDefault) {
          optionCopy.label = (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {optionCopy.label}
              <StarIcon sx={{ fontSize: '13px' }} />
            </Box>
          );
        }
        return optionCopy;
      })}
      accessors={{ valueAccessor: 'value', textAccessor: 'label' }}
      value={currentLanguage}
      onChange={(e) => onChange(e.target.value)}
      sx={{
        marginTop: '3px',
        fontSize: '13px',
        height: '30px',
        width: '150px',
        '& > div': {
          p: '4px 12px',
        },
        marginRight: '20px',
        marginLeft: 'auto',
      }}
    />
  );
}
